import React from 'react';
import { useSpring, animated, config } from '@react-spring/web'
import { withTranslation } from 'react-i18next';



function HomeCountdown(props) {


  const propsSpring = useSpring({
     opacity: 1,
     delay: 1000,
     transform: "translate(0px, -50%)",
     from: { opacity: 0, transform: "translate(0%, 1000%)" },
     config: config.slow
   });

  return (

    <animated.div style={propsSpring} className="countdown-bar">

      <h2 className="date-day">19 – 20</h2><br />
      <h2 className="date-month">{props.t('Juni')}</h2>
      <h3>2027</h3>

    </animated.div>

  );
}

export default withTranslation()(HomeCountdown);
